import { defineComponent } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import JobStatusRenderer from '@/components/Job/JobStatusRenderer.vue';

function jobSubmitStatus(status = 'PENDING') {
  if (status === 'PENDING') return 'text-white bg-orange-500 text-center rounded-xl';
  if (status === 'CANCELLED') return 'text-white bg-red-500 text-center rounded-xl';
  return 'text-white bg-green-500 text-center rounded-xl';
}

export const _primaryControls = {
  width: '3rem',
  name: 'เมนู',
};

export const _increment = {
  width: '2rem',
  class: 'text-center',
};

export const code = {
  name: 'Job No',
  width: '8rem',
  class: 'text-left',
};

export const name = {
  name: 'Project Name',
  width: '1fr',
  class: 'text-center',
};

export const amount = {
  name: 'จำนวนสั่งทำ',
  width: '6rem',
  class: 'text-right',
  // eslint-disable-next-line
  filter: (val: string, row: any) => `${val} ${row.item?.unit}`,
};

export const type = {
  name: 'ประเภทงาน',
  width: '7rem',
  class: 'text-center',
  // eslint-disable-next-line
  filter: (val: string) => val === 'AUTOMATION' ? 'Automation' : 'Machine Part',
};

export const customer_id = {
  name: 'ลูกค้า',
  width: '15rem',
  class: {
    cell: 'text-left',
    text: 'text-gray-500 font-bold',
  },
  filter: (val: any, row: any) => row.item.customer?.name,
};

export const quotation = {
  name: 'Quotaion No.',
  width: '8rem',
};

export const status = {
  name: 'การส่งงาน',
  width: '6rem',
  class: {
    text: (val: string) => jobSubmitStatus(val),
  },
  // eslint-disable-next-line
  filter: (val: string) => val === 'PENDING' ? 'ยังไม่ถูกส่ง' : val === 'CANCELLED' ? 'ยกเลิก' : 'ส่งเรียบร้อย',
};

export const targetDateWarning = {
  name: 'สถานะ',
  width: '10rem',
  class: 'text-center',
  component: defineComponent({
    render(createElement: any) {
      return createElement(
        JobStatusRenderer,
        {
          attrs: {
            targetDate: (this as any).row.item.target_date || 'NORMAL',
            status: (this as any).row.item.status || 'PENDING',
          },
          props: { row: {} },
        },
      );
    },
    props: { row: {} },
  }),
  filter: () => '',
};

export const bom_stats = {
  name: 'SUB JOB',
  width: '8.5rem',
  class: 'text-center',
};

export const totalExpenses = {
  name: 'งบที่ใช้ไป',
  width: '6rem',
  class: 'text-right',
  filter: (val: string, row: any) => `${parseFloat(row.item?.bom_stats?.totalExpenses || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} ฿ `,
};

export const created_at = {
  name: 'วันที่สร้าง',
  width: '10rem',
  class: 'text-right',
  // eslint-disable-next-line
  filter: (val: string) => val ? useFormat.date(val).displayFullThaiDate() : '',
};

export const target_date = {
  name: 'กำหนดส่ง',
  width: '10rem',
  class: 'text-right',
  // eslint-disable-next-line
  filter: (val: string) => val ? useFormat.date(val).displayFullThaiDate() : '',
};
